import * as React from "react";
import { ErrataView } from "../service/index.js";
import { Section } from "./Section.jsx";
export { ErrataSection, ErrataView };
/**
 * Вывод отчёта об ошибках как секции учебного продукта.
 * @param {Object} props - Атрибуты элемента.
 * @param {Errata} props.errata - Отчёт об ошибке.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {ErrataSection} from "../personal-studio-components/product/index.js";
 * if(request.hasError()) return <ErrataSection errata={request.getErrata()}/>;
 * @see {@link ../service/ErrataView.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ErrataSection({ errata = {} }) {
  return (
    <Section icon="warn" title="Произошла ошибка">
      <ErrataView errata={errata} />
    </Section>
  );
}
